import { MINUTES_IN_DAY } from './time-constants';

export const getNumberOfOptions = (
  firstPossibleCalcMinutes: number,
  generatedOptionIncrementMinutes: number
): number => {
  // total number of possible options - the number of complete generatedOptionIncrementMinutes segments wer are in to the day
  return Math.floor(
    MINUTES_IN_DAY / generatedOptionIncrementMinutes -
      Math.floor(firstPossibleCalcMinutes / generatedOptionIncrementMinutes)
  );
};
